// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/authentication.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_v1_config } from "./config_pb";
import type { StringValueSchema } from "../types/value_pb";
import { file_types_value } from "../types/value_pb";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/authentication.proto.
 */
export const file_v1_authentication: GenFile = /*@__PURE__*/
  fileDesc("Chd2MS9hdXRoZW50aWNhdGlvbi5wcm90bxICdjEiMgoMTG9naW5SZXF1ZXN0EhAKCHVzZXJuYW1lGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJIh4KDUxvZ2luUmVzcG9uc2USDQoFdG9rZW4YASABKAkyegoOQXV0aGVudGljYXRpb24SLgoFTG9naW4SEC52MS5Mb2dpblJlcXVlc3QaES52MS5Mb2dpblJlc3BvbnNlIgASOAoMSGFzaFBhc3N3b3JkEhIudHlwZXMuU3RyaW5nVmFsdWUaEi50eXBlcy5TdHJpbmdWYWx1ZSIAQixaKmdpdGh1Yi5jb20vZ2FyZXRoZ2VvcmdlL2JhY2tyZXN0L2dlbi9nby92MWIGcHJvdG8z", [file_v1_config, file_types_value, file_google_protobuf_empty, file_google_api_annotations]);

/**
 * @generated from message v1.LoginRequest
 */
export type LoginRequest = Message<"v1.LoginRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_v1_authentication, 0);

/**
 * @generated from message v1.LoginResponse
 */
export type LoginResponse = Message<"v1.LoginResponse"> & {
  /**
   * JWT token
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_v1_authentication, 1);

/**
 * @generated from service v1.Authentication
 */
export const Authentication: GenService<{
  /**
   * @generated from rpc v1.Authentication.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc v1.Authentication.HashPassword
   */
  hashPassword: {
    methodKind: "unary";
    input: typeof StringValueSchema;
    output: typeof StringValueSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_authentication, 0);

